module.exports = __webpack_public_path__ + "media/slot-game/champagne-00c3649d.svg";